import { z } from 'zod';
import { ERROR_LEVELS, ERROR_SOURCES } from './errors.js';
import { PageQuerySchema } from './pagination.js';

export const ErrorLogQuerySchema = z
  .object({
    source: z.enum(ERROR_SOURCES).optional(),
    level: z.enum(ERROR_LEVELS).optional(),
    code: z.string().max(100).optional(),
    runId: z.uuid().optional(),
    formId: z.uuid().optional(),
    userId: z.string().max(100).optional(),
    requestId: z.string().max(100).optional(),
    resolved: z.enum(['yes', 'no']).optional(),
    from: z.iso.datetime({ offset: true }).optional(),
    to: z.iso.datetime({ offset: true }).optional(),
  })
  .extend(PageQuerySchema.shape);
export type ErrorLogQuery = z.infer<typeof ErrorLogQuerySchema>;

export interface ErrorLogSummary {
  id: string;
  occurredAt: string;
  level: string;
  source: string;
  code: string;
  message: string;
  path: string | null;
  statusCode: number | null;
  requestId: string | null;
  user: { id: string; name: string | null; role: string | null } | null;
  runId: string | null;
  formId: string | null;
  jobName: string | null;
  fingerprint: string;
  resolvedAt: string | null;
}

export interface ErrorLogDetail extends ErrorLogSummary {
  stack: string | null;
  cause: unknown;
  httpMethod: string | null;
  atlasRunId: string | null;
  jobId: string | null;
  context: unknown;
  appVersion: string | null;
  host: string | null;
  userAgent: string | null;
  resolvedBy: { id: string; name: string } | null;
  resolutionNote: string | null;
  occurrences: { count: number; firstSeen: string; lastSeen: string };
}

export interface ErrorGroup {
  fingerprint: string;
  code: string;
  source: string;
  message: string;
  count: number;
  unresolved: number;
  firstSeen: string;
  lastSeen: string;
  latestId: string;
}

export const ResolveErrorSchema = z.object({
  note: z.string().trim().max(2000).optional(),
  /** Resolve every unresolved occurrence with the same fingerprint. */
  allOccurrences: z.boolean().default(false),
});
